<template>
  <div id="app">
    <router-view> </router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    const that = this;
  },
};
</script>

<style lang="less">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
.toptitle {
  background-color: #0062ab;

  color: white;
  font-size: 15px;
  text-align: left;
  .tit {
    font-weight: bold;
  }
}

.el-form-item {
  text-align: left;
  margin-bottom: 10px;
}


  .el-tree-node__content {
    padding: 8px 0;
  }
  .el-card__body{
    padding: 3px;
  }
  .el-tabs__header {
    padding: 0;
    position: relative;
    margin: 0 0 5px;
    
  }
  .el-drawer__body {
    flex: 1;
    overflow: auto;
  }
  .el-input-number--mini {
      width: 100px;
      line-height: 26px;
  }
</style>
